import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninAbandoned = (
  track: RedcatAnalyticsStore['track'],
  { fieldsCompletedCount, timeInFlowSec }: { fieldsCompletedCount: number; timeInFlowSec: number },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.Abandoned,
    properties: {
      fields_completed_count: fieldsCompletedCount,
      time_in_flow_sec: timeInFlowSec,
    },
  };

  track(event);
};
